/**
 * @file Identity Create action.
 */

import axios from 'axios';

import { photoUploadSuccess } from './photo-upload';
import getLogger from '../util/logger';
import { getErrorString } from '../util/normalize-errors';

const log = getLogger('IdentityCreateAction');

export const IDENTITY_CREATE_REQUEST = 'identity/CREATE_REQUEST';
export const IDENTITY_CREATE_SUCCESS = 'identity/CREATE_SUCCESS';
export const IDENTITY_CREATE_FAILURE = 'identity/CREATE_FAILURE';
export const IDENTITY_CREATE_RESET = 'identity/CREATE_RESET';

const identityCreateRequest = () => {
  return { type: IDENTITY_CREATE_REQUEST };
};

const identityCreateSuccess = identity => {
  return { type: IDENTITY_CREATE_SUCCESS, identity };
};

const identityCreateFailure = error => {
  return { type: IDENTITY_CREATE_FAILURE, error };
};

export const identityCreateReset = () => {
  return { type: IDENTITY_CREATE_RESET };
};

export const identityCreate = async (
  accountId,
  identityName,
  identityLastName,
  file,
  dispatch,
  photosUploadMutation,
  identityCreateMutation,
) => {
  log.info('identityCreate() :: Creating identity...', identityName);

  dispatch(identityCreateRequest());

  try {
    const photoUploadsRes = await photosUploadMutation(accountId, [
      { filename: file.name, content_type: file.type },
    ]);

    const photoUploadData = photoUploadsRes.data.photosUpload.photo_uploads[0];
    const photoId = photoUploadData.photo_id;

    await axios.put(photoUploadData.upload_url, file, {
      headers: {
        'Content-Type': file.type,
      },
    });

    const identityCreateRes = await identityCreateMutation(
      accountId,
      identityName,
      identityLastName,
      photoId,
    );
    const { identity } = identityCreateRes.data.identityCreate;

    log.info('identityCreate() :: Identity created');

    dispatch(
      photoUploadSuccess({ id: photoId, identityId: identity.id, file }, true),
    );
    dispatch(identityCreateSuccess(identity));

    return identity;
  } catch (error) {
    log.error('identityCreate() :: Error:', error);

    dispatch(identityCreateFailure(getErrorString(error)));
    return undefined;
  }
};
